// Generated by purs version 0.13.8
"use strict";
var Control_MonadZero = require("../Control.MonadZero/index.js");
var DOM_HTML_Indexed_InputType = require("../DOM.HTML.Indexed.InputType/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var switchWidth = 54.0;
var switchHeight = 28.0;
var $$switch = function (v) {
    return function (handleCheck) {
        return Halogen_HTML_Elements.label([ Lunarbox_Component_Utils.className("switch") ])([ Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.checked(v.checked), Halogen_HTML_Events.onChecked(handleCheck) ]), Halogen_HTML_Elements.span([ Halogen_HTML_Properties.classes(Data_Functor.map(Data_Functor.functorArray)(Halogen_HTML_Core.ClassName)(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ "switch-slider" ])(Data_Functor.voidRight(Data_Functor.functorArray)("round")(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(v.round))))) ])([  ]) ]);
    };
};
module.exports = {
    switchHeight: switchHeight,
    switchWidth: switchWidth,
    "switch": $$switch
};
